import { NgModule } from '@angular/core';

// Composants graphiques utilises

// Module metier utilises

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { TypeQualificationService } from './services/type-qualification.service';

// Pipes

@NgModule({
	imports: [
	],
	providers: [
		TypeQualificationService,
	],
	declarations: [
	],
	exports: [
	]
})
export class TypeQualificationModule {
	constructor() { }
}